import $ from 'jquery';
import URI from 'urijs';

const parseCurrentReferer = () => {
  const { referer } = URI.parseQuery(window.location.search);
  return referer;
};

const appendRefererToUrl = (href, referer, from) => {
  const uri = URI(href);
  uri.addQuery('referer', referer);

  if (from && from.length) {
    uri.addQuery('from', from);
  }

  return uri;
};

// TODO: Migrate contextual button handling server side
export default function bind() {
  const currentUrl = window.location.pathname;

  // Checking for current referer
  const referer = parseCurrentReferer();

  const appendRefererToHref = href =>
    appendRefererToUrl(href, currentUrl, referer);

  const keepRefererInUrl = href => {
    const uri = URI(href);
    if (referer && referer.length) {
      uri.addQuery('referer', referer);
    }

    return uri;
  };

  const appendReferer = (index, element) => {
    const $element = $(element);
    $element.attr('href', appendRefererToHref($element.attr('href')));
  };

  const keepReferer = (index, element, attribute = 'href') => {
    const $element = $(element);
    $element.attr(attribute, keepRefererInUrl($element.attr(attribute)));
  };

  $('.button.contextual').each(appendReferer);
  $('form').each((i, e) => keepReferer(i, e, 'action'));
}

export const withReferer = (url, referer) => {
  if (url && url.length) {
    const from = parseCurrentReferer();

    return appendRefererToUrl(url, referer, from).toString();
  }

  return null;
};

export const withCurrentReferer = url => {
  if (url && url.length) {
    const uri = URI(url);
    const referer = parseCurrentReferer();
    uri.addQuery('referer', referer);

    return uri.toString();
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/plugins/contextual-back.js